import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AuthFormStep, DpeTileStep, } from '@as-react/common-types';
import { connect } from 'react-redux';
import { DpePopup } from '../components/dpe/dpe-popup/DpePopup';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { authActions } from '../redux/authentication/actions/AuthActions.creators';
import { makeGetAuthStatus, makeGetLoginError, makeGetLoginLoading, } from '../redux/authentication/selectors/AuthSelectors';
import { authFormActions } from '../redux/authForm/actions/AuthFormActions.creators';
import { makeGetAuthFormStep } from '../redux/authForm/selectors/AuthFormSelectors';
const DpePopupContainer = ({ authFormStep, onAnalyticsStart, data, digitalPartner, onAuthFormStepUpdate, onAnalyticsStepAuthChange, onAnalyticsStepEligibilityCheck, onAnalyticsStepConfirmation, onAnalyticsStepLeave, onCloseClick, isAuthenticated, loginState, onLogin, onAnalyticsFormsError, }) => {
    const [digitalPartnerEnrolmentStep, setDigitalPartnerEnrolmentStep] = useState(DpeTileStep.INTRO);
    const onAuthFormStepUpdateLocal = (step) => {
        onAuthFormStepUpdate(step);
        onAnalyticsStepAuthChange(step, {
            partner: digitalPartner,
        });
        setDigitalPartnerEnrolmentStep(null);
    };
    useEffect(() => {
        if (authFormStep === AuthFormStep.EMAIL) {
            onAnalyticsStart({ partner: digitalPartner });
            onAuthFormStepUpdateLocal({
                to: AuthFormStep.EMAIL,
                from: AuthFormStep.EMAIL,
            });
        }
    }, []);
    const onEnrolmentStepUpdate = (step) => {
        if (step.to === DpeTileStep.VALIDATION) {
            onAnalyticsStepEligibilityCheck({
                partner: digitalPartner,
            });
        }
        else if (step.to === DpeTileStep.CONFIRMATION) {
            onAnalyticsStepConfirmation({
                partner: digitalPartner,
            });
        }
        setDigitalPartnerEnrolmentStep(step.to);
    };
    const handleCloseClick = () => {
        if (authFormStep !== AuthFormStep.EMAIL) {
            onAuthFormStepUpdate({
                to: AuthFormStep.EMAIL,
                from: authFormStep,
            });
        }
        if (!(!!digitalPartnerEnrolmentStep && digitalPartnerEnrolmentStep === DpeTileStep.CONFIRMATION)) {
            onAnalyticsStepLeave({
                partner: digitalPartner,
            });
        }
        onCloseClick();
    };
    return (_jsx(DpePopup, { data: data, digitalPartner: digitalPartner, onConfirmationClick: handleCloseClick, isAuthenticated: isAuthenticated, authFormStep: authFormStep, onAuthFormStepUpdate: onAuthFormStepUpdate, onEnrolmentStepUpdate: onEnrolmentStepUpdate, loginState: loginState, onLogin: onLogin, onFormValidationError: onAnalyticsFormsError }));
};
const makeMapStateToProps = () => {
    const getAuthFormStep = makeGetAuthFormStep();
    const getAuthStatus = makeGetAuthStatus();
    const getLoginLoading = makeGetLoginLoading();
    const getLoginError = makeGetLoginError();
    return (state) => ({
        loginState: {
            success: getAuthStatus(state),
            loading: getLoginLoading(state),
            error: getLoginError(state),
        },
        authFormStep: getAuthFormStep(state),
    });
};
const mapDispatchToProps = {
    onLogin: authActions.login,
    onAuthFormStepUpdate: authFormActions.updateStep,
    onAnalyticsStepAuthChange: analyticsActions.digitalPartnerEnrolmentStepAuth,
    onAnalyticsStepEligibilityCheck: analyticsActions.digitalPartnerEnrolmentStepEligibilityCheck,
    onAnalyticsStepConfirmation: analyticsActions.digitalPartnerEnrolmentStepConfirmation,
    onAnalyticsStepLeave: analyticsActions.digitalPartnerEnrolmentLeave,
    onAnalyticsFormsError: analyticsActions.formsErrorMessage,
    onAnalyticsStart: analyticsActions.digitalPartnerEnrolmentStart,
};
export default connect(makeMapStateToProps, mapDispatchToProps)(DpePopupContainer);
